import { DateTime } from 'luxon';
import React from 'react';
import { Select } from '/imports/ui/Select';

const presetOptions = [
  { value: 'custom', label: 'Custom' },
  { value: '1d', label: '1 Day' },
  { value: '3d', label: '3 Days' },
  { value: '7d', label: '7 Days' },
  { value: '30d', label: '30 Days' },
  { value: '12m', label: '12 Months' },
  { value: 'ytd', label: 'Year to Date' },
];

interface DateRangePresetSelectProps {
  value: string;
  onChange(preset: string, startDate?: string, endDate?: string): void;
}

/**
 * Select for date-range presets that emits the resolved start/end dates on change.
 */
export const DateRangePresetSelect = (props: DateRangePresetSelectProps) => {
  /**
   * Resolves a preset into start/end dates and forwards them via onChange.
   * @param value - selected preset value
   */
  const onPresetChange = (value: string) => {
    if (value === 'custom') {
      props.onChange(value);
      return;
    }
    const now = DateTime.now();
    let startDate: string;
    const endDate = now.toFormat('yyyy-MM-dd');
    switch (value) {
      case '1d': startDate = now.plus({ days: -1 }).toFormat('yyyy-MM-dd'); break;
      case '3d': startDate = now.plus({ days: -3 }).toFormat('yyyy-MM-dd'); break;
      case '7d': startDate = now.plus({ days: -7 }).toFormat('yyyy-MM-dd'); break;
      case '30d': startDate = now.plus({ days: -30 }).toFormat('yyyy-MM-dd'); break;
      case '12m': startDate = now.plus({ months: -12 }).toFormat('yyyy-MM-dd'); break;
      case 'ytd': startDate = now.startOf('year').toFormat('yyyy-MM-dd'); break;
      default: return;
    }
    props.onChange(value, startDate, endDate);
  };
  return <Select value={props.value} options={presetOptions} onChange={onPresetChange} />;
};
